import {BaseComponent} from '../shared/components/base.component';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SignoutService} from './signout.service';

@Component({
  selector: 'app-signout',
  templateUrl: './signout.component.html',
  styleUrls: ['./signout.component.scss'],
  providers: [SignoutService]
})
export class SignoutComponent extends BaseComponent implements OnInit {

  public isActionInProgress: boolean;
  public wasSignOutSuccessfull: boolean;

  constructor(private router: Router, private route: ActivatedRoute, private signoutService: SignoutService) {
    super();
  }

  ngOnInit() {
    this.signOut();
  }

  public signOut() {
    this.isActionInProgress = true;
    this.signoutService.signout().subscribe(
      () => {
        this.wasSignOutSuccessfull = true;
        this.goToLoginPage();
      },
      () => {
        this.isActionInProgress = false;
        this.wasSignOutSuccessfull = false;
      },
      () => this.isActionInProgress = false
    );
  }

  public goToLoginPage() {
    this.router.navigateByUrl('/login');
  }
}
